
      const supervise = {
  "superviseOrg": "Организация",
  "group": "Группа",
  "correctTime": "Скорректировать время",
  "correctPlan": "Скорректировать план",
  "isBindDevice": "Привязать устройство",
  "absent": "Запрос на выход из зоны",
  "Male": "Пол",
  "male": "муж.",
  "female": "жен.",
  "name": "Имя",
  "identityID": "ID",
  "birthday": "День рождения",
  "phone": "Номер телефона",
  "address": "Адрес",
  "fenceType": "Тип зоны",
  "defaultGroup": "Группа по умолчанию",
  "groupName": "Имя группы",
  "groupDescription": "Описание группы",
  "applyChild": "Применить к подразделениям",
  "applyChildTip": "Применить ко всем подразделениям",
  "editSuperviseRule": "Отредактировать правило",
  "groupAliasName": "Название",
  "groupNameRequired": "Требуется название группы",
  "nameRule": "Не более 30 символов",
  "aliasNameRequired": "Пожалуйста введите название",
  "descriptionRequired": "Пожалуйста введите описание",
  "descriptionRule": "Не более 200 символов",
  "option": "Опции",
  "locateFreq": "Частота обновления",
  "locateFreqBase": "Частота определения местоположения WIFI / базовой станции",
  "locateFreqBle": 'Частота определения местоположения Bluetooth',
  "locateFreqGps": 'Частота определения местоположения GPS',
  "autoAdjust": "Авто настройка частоты",
  "autoPowerUp": "Авто включение",
  "autoPowerDown": "Авто выключение",
  "customLocate": "Настройка сегментов",
  "modelLocate": 'Параметры классификации',
  "segmentTime": "Время",
  "segmentFreq": "Частота",
  "selecteTimeTip": "Выберете время",
  "powerTip": "Включение и выключение настраиваются вместе",
  "smartRule": "Интеллектуальные правила",
  "timeingName": "Частота обновления",
  "timeingHeart": "Частота обновления пульса",
  "time": "Время",
  "mapFence": "Зона",
  "inheritMapFence": "Зона",
  "ownedMapFence": "Собственная зона",
  "circle": "Круг",
  "polygon": "Многоугольник",
  "district": "Район",
  "fenceName": "Название зоны",
  "forbidType": "Тип ограничения",
  "timeOption": "Время",
  "center": "Центр",
  "radius": "Радиус",
  "newGroup": "Создать новую группу",
  "complete": "Завершить",
  "templateName": "Наименование шаблона",
  "templateDescription": "Описание шаблона",
  "addEntity": "Добавить",
  "reason": "Причина",
  "preBack": "Возвращение",
  "backTip": "Для продления сначала введите свой статус",
  "bindEntity": "Привязать",
  "fingerManage": "Управление домашними зонами",
  "fingerName": "Название",
  "fingErrMsg": "Пожалуйста введине название",
  "reCollect": "Необходимо собрать данные повторно",
  "noNeed": "Нет",
  "need": "Да",
  "collectTime": "Время",
  "fingerEdit": "Модификация",
  "fingerAdd": "Добавить",
  "segInfo": "Информация об изоляции",
  "segStart": "Начало изоляции",
  "segEnd": "Конец изоляции",
  "segAddr": "Адрес изоляции",
  "bindTip": "Возможно связать только устройства, относяциеся к этой организации",
  "isBinding": "Связано",
  "entityInfo": "Информация",
  "noPic": "Нет фото",
  "editEntity": "Изменить",
  "personalConfig": "Персональные данные",
  "groupConfig": "Групповые данные",
  "addTimeOption": "Добавить время",
  "personalFence": "Персональная зона",
  "noPersonalFence": "Персональная зона не создана",
  "drawFence": "Начертить зону",
  "drawByWheel": "Начертить кругом",
  "addPersonalFence": "Добавить зону",
  "selectDistrict": "Выбрать район",
  "fenceCenter": "Центр",
  "editFence": "Изменить",
  "deleteFence": "Удалить",
  "commitEdit": "Принять изменения",
  "importEntitys": "Импорт",
  "downloadTemplate": "Загрузить шаблон",
  "entityTemplate": "Шаблон",
  "selectedValue": "Значение может быть только одно из (_____)",
  "segregation": "Информация об изоляции",
  "segregationTime": "Время изоляции",
  "segregationAddress": "Адрес изоляции",
  "selectSegregationTime": "Введите время",
  "segregationStart": "Начало изоляции",
  "alwaysOpen": "Всегда включено",
  "theTip": "Личная опция имеет приоритет над групповой опцией, групповая опция будет перезаписана, когда личная опция существует, опция в действительности всегда отображается темным шрифтом",
  indoorMap:'Карта в помещении',
  outdoorMap:'Карта на открытом воздухе',
  fenceNumberTip:'Количество запрещенных заборов поддерживает чертеж 10, а количество запрещенных заборов поддерживает рисунок 1.',
  mapType:'Тип карты',
  scene:'Сцена',
  操作成功:'Успешная работа',
  yzkj:'Включай его все время',
  locationType:'Режим определения местоположения',
}
      export default supervise
